export default {
    subscription: {
        title: 'O Astrolink é <em>ainda melhor</em> no aplicativo!',
        lead: 'Assine o Premium pela App Store ou pelo Google Play. É mais completo, mais acessível e você cancela quando quiser.',
        leadMobile: 'Mais completo, mais acessível e você cancela quando quiser.',

        benefits: {
            complete: {
                title: 'Mais completo',
                description: 'A experiência completa do Astrolink, feita para o celular e sempre com você.'
            },
            affordable: {
                title: 'Mais acessível',
                description: 'Assinar pelo app custa menos do que pelo site.'
            },
            cancel: {
                title: 'Cancele em dois toques',
                description: 'Gerencie ou cancele nas configurações de assinatura do celular. Sem e-mail, sem formulário, sem perguntas.',
                descriptionMobile: 'Direto nas configurações de assinatura do celular. Sem e-mail, sem formulário.'
            },
            account: {
                title: 'Tudo o que você já tem',
                description: 'Entre com o mesmo e-mail. Seus mapas, relatórios e histórico já estão lá.',
                descriptionMobile: 'Entre com o mesmo e-mail e seus mapas já estarão lá.'
            }
        },

        steps: {
            confirmIos: 'Toque em Premium e confirme com Face ID',
            confirmAndroid: 'Toque em Premium e confirme com sua conta Google'
        }
    },

    purchase: {
        title: 'Finalize sua compra no app Astrolink',
        lead: 'Compre pelo app com a mesma conta que você usa aqui.',
        leadMobile: 'Compre pelo app com a mesma conta que você usa aqui.',

        benefits: {
            sameAccount: {
                title: 'Mesma conta',
                description: 'Entre com o mesmo e-mail que você usa aqui'
            },
            securePayment: {
                title: 'Pagamento seguro',
                description: 'Feito pela Apple ou pelo Google'
            },
            availableNow: {
                title: 'Acesso imediato',
                description: 'Disponível logo após o pagamento'
            }
        },

        steps: {
            confirm: 'Encontre o seu produto e confirme o pagamento',
            confirmIos: 'Encontre o seu produto e confirme com Face ID',
            confirmAndroid: 'Encontre o seu produto e confirme com sua conta Google'
        }
    },

    securePayment: 'O pagamento é feito pela Apple ou pelo Google. O Astrolink nunca vê o seu cartão.',
    otherPhone: 'Outro celular?',

    steps: {
        title: 'Como funciona',
        install: 'Instale o app',
        login: 'Entre com o e-mail que você usa aqui'
    },

    qrCode: {
        tag: 'Baixe o app',
        title: 'Aponte a câmera do celular e a loja abre.',
        caption: 'Entre com o mesmo e-mail que você usa aqui.',
        iphone: 'iPhone',
        android: 'Android',
        alt: 'Aponte a câmera do celular e a loja abre.'
    },

    badges: {
        apple: 'Baixar na App Store',
        play: 'Disponível no Google Play'
    }
};
